//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    
    data: () => ({
        info:'',
        identifier:''
    }),
    methods: {
         //获取个人信息
        getInfo(){
            this.$get('/sys/user/info','',function(res){
                if(res.code==200){
                    this.info=res.data;
                    this.identifier= res.data.userAuth.identifier
                }
            })
        },
        //修改手机号
        changeNum(){
            this.$router.push({
                path:'/person/changeNum'
            })
        },
         //修改密码
        changePwd(){
            this.$router.push({
                path:'/person/changePwd'
            })
        },
    },
    mounted() {
       this.getInfo()
    }
}
